import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";
import { createTheme } from '@mui/material/styles';

const theme = createTheme();

export const useStyles = () => ({
    /** MuiStepIcon */
    horizontal: css({
        paddingLeft: "16px",
        paddingRight: "16px",
        "&:first-child": {
            paddingLeft: "0px"
        },
        "&:last-child": {
            paddingRight: "0px"
        }
    }),
    vertical: css({
        "&:first-child": {
            paddingLeft: "0px"
        },
        "&:last-child": {
            paddingRight: "0px"
        }
    }),
    /** MuiStepIcon */
    root: css({
        width: "24px",
        height: "24px",
        borderRadius: "12px",
        fontFamily: "roboto-medium",
        fontSize: "16px",
        background: Color.neutral[300],
        color: Color.neutral[100]
    }),
    active: css({
        background: Color.primary[400],
        color: Color.neutral[100]
    }),
    completed: css({
        borderRadius: "12px",
        background: Color.primary[400],
        color: Color.neutral[100]
    }),
    iconText: css({
        fontFamily: "roboto-medium",
        fontSize: "16px",
        marginLeft: "7px",
        lineHeight: "25px"
    }),
    /** MuiStepLabel */
    iconContainer: css({
        paddingRight: "16px",
        display: "flex",
        alignItems: "center"
    }),
    label: css({
        fontFamily: "roboto",
        fontSize: "16px",
        letterSpacing: "0.2px",
        color: Color.neutral[400]
    }),
    labelActive: css({
        fontFamily: "roboto-medium"
    }),
    labelCompleted: css({
        color: `${Color.neutral[400]} !important`
    }),
    rootContainer: css({
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100% - 85px - 27px)"
    }),
    stepperContainer: css({
        [theme.breakpoints.up('md')]: {
            // paddingLeft: "5%",
            // paddingRight: "5%"
        },
        [theme.breakpoints.up('lg')]: {
            // paddingLeft: "10%",
            // paddingRight: "10%"
        }
    }),
    stepper: css({
        "&.MuiStepper-root": {
            position: "sticky",
            top: "64px",
            paddingLeft: 0,
            paddingRight: 0
        }
    }),
    bottomNav: css({
        marginTop: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "64px",
        background: Color.neutral[800],
        [theme.breakpoints.up('md')]: {
            paddingLeft: "5%",
            paddingRight: "5%"
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: "10%",
            paddingRight: "10%"
        }
    })
});
